import { useTranslation } from 'react-i18next'
import { Box, Paper, Typography } from '@mui/material'
import { imageUrl } from '../photo-review/reviewModel'

// "Fotos para refazer" — the list of items with at least one rejected shot,
// shown at the top of the upload page. One group per item (oldest rejection
// first, per the server's ordering), with every rejected raw side by side so
// it reads on a phone. Tapping a thumbnail or the header opens that item
// exactly as a barcode scan would (PhotoUpload's handleSubmitSku, passed in
// as onOpen).
export default function RejectedShots({ groups, onOpen, slotLabel }) {
    const { t, i18n } = useTranslation()
    if (!groups?.length) return null

    const formatDate = iso => new Date(iso).toLocaleString(i18n.language)

    return (
        <Box sx={{ width: '100%', maxWidth: '380px', display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
            <Typography variant='h6'>{t('photoUpload.rejected.title')}</Typography>
            {groups.map(group => (
                <Paper
                    key={group.sku}
                    data-testid={`rejected-group-${group.sku}`}
                    variant='outlined'
                    role='button'
                    tabIndex={0}
                    onClick={() => onOpen(group.sku)}
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') onOpen(group.sku); }}
                    sx={{ p: 1.5, cursor: 'pointer', textAlign: 'left' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                        {group.imageUrl && (
                            <img
                                src={group.imageUrl}
                                alt={t('photoUpload.productAlt')}
                                style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4, flexShrink: 0 }}
                            />
                        )}
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography sx={{ fontWeight: 600 }}>{group.sku}</Typography>
                            {group.category && <Typography variant='body2' color='text.secondary'>{group.category}</Typography>}
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                        {group.shots.map(shot => (
                            <Box
                                key={shot.photoId}
                                sx={{ width: 104 }}
                                onClick={e => { e.stopPropagation(); onOpen(group.sku); }}
                            >
                                <img
                                    src={imageUrl(shot.photoId, 'raw', shot.rawVersion)}
                                    alt={slotLabel(shot.slot)}
                                    style={{ width: 104, height: 104, objectFit: 'cover', borderRadius: 4, display: 'block', cursor: 'pointer' }}
                                />
                                <Typography variant='caption' sx={{ display: 'block', fontWeight: 600 }}>{slotLabel(shot.slot)}</Typography>
                                <Typography variant='caption' color='error' sx={{ display: 'block' }}>
                                    {t(`photoReview.reject.reasons.${shot.reason}`)}
                                </Typography>
                                {shot.note && (
                                    <Typography variant='caption' color='text.secondary' sx={{ display: 'block' }}>{shot.note}</Typography>
                                )}
                                <Typography variant='caption' color='text.secondary' sx={{ display: 'block' }}>
                                    {t('photoUpload.rejected.rejectedOn', { date: formatDate(shot.rejectedAt) })}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Paper>
            ))}
        </Box>
    )
}
